import React from "react";
import Tooltip from "@/src/components/common/Elements/Tooltip/Tooltip";
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import EmojiMartPicker from "@/src/components/common/Elements/EmojiMartPicker/EmojiMartPicker";

class Emoji extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            openPicker: false,
            emoji:false
        }

        _.map(
            ["handleShowEmoticons", "handleSelectEmoticon"], fn => {
                this[fn] = this[fn].bind(this);
            }
        );
    }

    handleShowEmoticons(e) {
        e.preventDefault();

        this.setState({
            ...this.state,
            openPicker: !this.state.openPicker,

        })
    }

    handleSelectEmoticon(value) {

        this.setState({
            ...this.state,
            'emoji': this.state['emoji'] ? false : true
        }, () => {
            this.props.onChange( value.native,this.state['emoji'] );
            //this.props.onChange( key, this.state[key] );
        })
        
    }
    
    handleBlur = () => {
        this.setState({...this.state, openPicker: false});
    }
   
    render() {

        return (
            <div class="toolbar-buttons emoji-buttons ">
                <a class={`logo-action text-black tooltip  ${this.state.openPicker ? "active" : ""}`}   data-tooltip-id="emoticon" onClick={this.handleShowEmoticons}>
                    <i class="material-icons">insert_emoticon</i>
                    <Tooltip id="emoticon" place="bottom" effect="solid">
                        Emoticon
                    </Tooltip>
                </a>
                {this.state.openPicker && (
                    <ClickAwayListener onClickAway={this.handleBlur}>
                        <div class="emojiPicker" style={{ top: '-445px',left: '-205px', zIndex:1000000}}>
                            <div class="emoji-wrapper">
                                <div class="emojiCloseHeader">
                                    <span>Select an emoji</span>
                                    <a class="emoji-icon-close" onClick={this.handleShowEmoticons}>
                                        <i class="material-icons">close</i>
                                    </a>
                                </div>
                                    <EmojiMartPicker
                                        onEmojiSelect={this.handleSelectEmoticon}
                                    />
                            </div>
                        </div>
                    </ClickAwayListener>
                )}
            </div>
        )
    }
}

Emoji.defaultProps = {
    type: "add"
}

export default Emoji;